import React from "react";
import { useTranslation } from "locales";
import BaseButton from "components/BaseButton";
import BaseIcon from "components/BaseIcon";
import useModalLinkPrinter from "../../../../../../hooks/useModalLinkPrinter";
import "./style.scss";

export default function BlockUniversityPartnerships() {
  const { t } = useTranslation();
  const { getLocation } = useModalLinkPrinter();

  const cards = [
    {
      label: t("Institutional entry point"),
      title: t("Workshop Programme"),
      subtitle: t("Visible, scalable, easy to budget."),
      button: t("Discuss a workshop"),
      dark: true,
      items: [
        t("Delivered to your whole cohort in a structured session format"),
        t("Tailored to the pathway: investment banking, capital markets, buy side, or risk"),
        t("Covers CV, technicals, behavioural prep, and market awareness"),
        t("Minimal admin - STO leads, your careers team benefits"),
        t("Pilot option available to validate fit before commitment"),
      ],
    },
    {
      label: t("Personalised follow-on"),
      title: t("1:1 Coaching Credit Bundle"),
      subtitle: t("Deeper preparation for students who need it."),
      button: t("Discuss a credit bundle"),
      dark: false,
      items: [
        t("Pre-purchased credit bundles at a discounted institutional rate"),
        t("Students self-book online - choose coach, focus area, and time slot"),
        t("Available as a follow-on from workshops or as a standalone add-on"),
        t("University receives anonymised ROI data and outcome tracking"),
        t("Bundle sizes: 25, 50, or 100 credits"),
      ],
    },
  ];

  return (
    <div className="block-university-partnerships">
      <h2 className="block-university-partnerships__title h2 mb-4 text-center mx-auto">
        {t("Two ways to partner with Secure The Offer")}
      </h2>
      <div className="block-university-partnerships__description subtitle-1 text-neutral-darken-1 mb-10 text-center mx-auto">
        {t(
          "Start with workshops. Add 1:1 coaching where it adds the most value. Both deliver measurable outcomes for your cohort."
        )}
      </div>
      <div className="block-university-partnerships__card-wrapper d-flex __wrap __justify-center">
        {cards.map((card, index) => (
          <div key={index} className="block-university-partnerships__card box-shadow d-flex __column pa-6">
            <div className="block-university-partnerships__card-label caption-2 fw-semibold text-uppercase mb-4">
              {card.label}
            </div>
            <h3 className="block-university-partnerships__card-title fw-bold mb-1">{card.title}</h3>
            <div className="block-university-partnerships__card-subtitle body-2 text-neutral-darken-1 mb-6">
              {card.subtitle}
            </div>
            <div className="block-university-partnerships__list d-flex __column">
              {card.items.map((item, itemIndex) => (
                <div key={itemIndex} className="block-university-partnerships__list-item body-1 d-flex">
                  <BaseIcon className="block-university-partnerships__list-icon f-shrink-0 mr-3" size={16}>
                    check
                  </BaseIcon>
                  <span>{item}</span>
                </div>
              ))}
            </div>
            <BaseButton
              className="block-university-partnerships__btn body-1 fw-semibold pl-4 pr-3 mt-auto"
              to={getLocation("/contact-us")}
              large
              dark={card.dark}
              gradient={!card.dark}
            >
              {card.button}
              <BaseIcon className="f-shrink-0 ml-2">chevron-right</BaseIcon>
            </BaseButton>
          </div>
        ))}
      </div>
    </div>
  );
}
